'use strict';
module.exports = {
	interactionRequiredErrors: ['interaction_required', 'consent_required', 'login_required', 'access_denied', 'invalid_grant'],
	storageKey: 'ms:auth-response',
	messagePrefix: 'oauth-authenticated#',
	endpointUrl: 'https://login.microsoftonline.com/common/oauth2/v2.0/'
};
